import { ParseObjectSelect } from "@opendash/plugin-parse";
import { Form } from "antd";
import { Rule } from "antd/es/form";
import React from "react";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
  targetClass: string;
};

export default (props: Props) => {
  return (
    <Form.Item
      label={props.label}
      name={[props.index, "value"]}
      rules={props.rules}
      style={props.styles}
    >
      <ParseObjectSelect
        mode="single"
        type={props.targetClass}
        style={props.styles}
      />
    </Form.Item>
  );
};
